<template>
  <div class="IntegratedGender">
    <h2>请选择适合你的套餐</h2>

    <template v-if="list.length != 0">
      <ul>
        <li v-for="item in list" :key="item.id">
          <img @click="link(item.productId)" :src="item.thumbnail" alt="">
        </li>
      </ul>
    </template>

  </div>
</template>

<script>
export default {
  name: "IntegratedGender",
  data() {
    return{
      data: {
        productCategory: this.$route.query.id,
        pageNum: 1,
        pageSize: 10,
      },
      list: []
    }
  },
  created() {
    this.get_list(this.data);
  },
  mounted() {

  },
  methods: {
    get_list(y) {
      this.$get("product",y)
        .then(res => {
          if(res) {
            this.list= res.data.pageInfo.list;
          }
        })
    },
    link(e) {
      this.$router.push({
        path: "/Deta",
        query: {
          id: e
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../../style/Make/Integrated/IntegratedGender";
</style>
